import { useCallback } from 'react';

import { TargetModel } from '../../../../../modules/Apps';
import { useConfirmationDialog } from '../../../../common/ConfirmationDialog';
import { useTargetsTableContext } from '../../TargetsTableContext';

export const useTargetsTableActions = () => {
  const {
    handleClose: handleCloseDisableDialog,
    handleOpen: handleOpenDisableDialog,
    isOpen: isOpenDisableDialog,
  } = useConfirmationDialog();

  const {
    handleClose: handleCloseEnableDialog,
    handleOpen: handleOpenEnableDialog,
    isOpen: isOpenEnableDialog,
  } = useConfirmationDialog();

  const {
    handleClose: handleCloseDeleteDialog,
    handleOpen: handleOpenDeleteDialog,
    isOpen: isOpenDeleteDialog,
  } = useConfirmationDialog();

  const { editTargetDrawerState, setEditingTarget, viewTargetDrawerState } =
    useTargetsTableContext();

  const openEditTargetDrawer = useCallback(
    (target: TargetModel) => () => {
      setEditingTarget(target);
      editTargetDrawerState.show();
    },
    [editTargetDrawerState, setEditingTarget],
  );

  const openViewTargetDrawer = useCallback(
    (target: TargetModel) => () => {
      setEditingTarget(target);
      viewTargetDrawerState.show();
    },
    [viewTargetDrawerState, setEditingTarget],
  );

  return {
    openEditTargetDrawer,
    handleCloseDisableDialog,
    handleOpenDisableDialog,
    isOpenDisableDialog,
    handleOpenEnableDialog,
    handleCloseEnableDialog,
    isOpenEnableDialog,
    openViewTargetDrawer,
    isOpenDeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
  };
};
